<template>
    <div class="d-flex flex-column align-center ga-2">
        <flight-class-selector :offer="offer" @select-class="categoryClass = $event" />
        <v-btn color="primary" @click="selectOffer">
            {{ $t('select') }}
        </v-btn>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import FlightClassSelector from '~/components/flights/search/schedule/FlightClassSelector.vue'

    @Component({
        components: {
            FlightClassSelector,
        },
    })
    export class ScheduleFlightSelector extends Vue {
        @Prop({required: true}) offer
        @Prop({required: true}) index

        categoryClass = null

        selectOffer() {
            const {index, offer, categoryClass} = this
            flightsStore.SET_SELECTED_SCHEDULE_ITEM({index, offer, categoryClass})
            this.$emit('select-offer')
        }
    }

    export default ScheduleFlightSelector
</script>
